export const T = {
  en_GB: {
    goalDescription: "Description",
    goalDescriptionPlaceholder: "Describe this goal (optional)",
  },
  nb_NO: {
    goalDescription: "Beskrivelse",
    goalDescriptionPlaceholder: "Beskriv dette målet (valgfritt)",
  },
} as const;
